export default "__VITE_ASSET__C1BKwBg5__"